import './styles.scss';

import { each } from 'lodash';

const CheckboxGroup = () => import('../../components/checkbox-group/index.vue');

export default {
    name: 'MessagingGroupTypesPage',

    components: {
        'checkbox-group': CheckboxGroup
    },

    data() {
        return {
            list: []
        }
    },

    computed: {
        subscription() {
            return this.$store.state.subscriptions.active_subscription;
        },

        stored_group_types() {
            return this.$store.state.messaging.group_types;
        },

        building() {
            return this.$store.getters.getActiveBuilding;
        },
        
        groups() {
            const groups = this.$store.getters.getActiveBuilding.groups;
            const all_groups = [];
            each(groups, (group) => {
                const obj = {
                    title: group.name,
                    id: group.id,
                    isChecked: false
                }
                all_groups.push(obj);
            });
            return all_groups;
        }
    },

    watch: {
        groups() {
            if (!this.stored_group_types.length) {
                this.list = this.groups;
                this.updateValues(this.groups);
            }
        }
    },

    created() {
        this.$store.commit('setMenuDetails', { 
            title: 'Emergency Messages', 
            slug: 'messaging',
            back_url: '/action/emergency-messages'
        });

        if (this.stored_group_types.length) {
            this.list = this.stored_group_types;
        }
        
        this.$store.dispatch('fetchBuildingProfile');
    },

    methods: {
        updateValues(list) {
            this.list = list;
            this.$store.commit('setMessageGroupTypes', list);
        },

        next() {
            this.$store.commit('setMessageGroupTypes', this.list);
            this.$router.push('/action/emergency-messages/floors');
        },

        cancel() {
            this.$ionic.alertController.create({
                header: 'Are you sure you want to cancel?',
                message: 'This action cannot be undone.',
                buttons: [
                    {
                        text: 'Yes',
                        handler: () => {
                            this.$store.commit('resetMessage');
                            this.$router.push('/action');
                        },
                    },
                    {
                        text: 'No',
                        role: 'cancel'
                    }
                ],
            }).then(a => a.present());
        }
    }
};